import React, { useState } from 'react';

const CookiesPage: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="website-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="/" className="logo-link">
              <img src="/assets/LogoBrown.png" alt="SobCof Logo" className="logo-img" />
            </a>
          </div>
          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="/" className="nav-link">Ana Sayfa</a>
            <a href="/#features" className="nav-link">Özellikler</a>
            <a href="/#how-it-works" className="nav-link">Nasıl Çalışır</a>
            <a href="/#download" className="nav-link">İndir</a>
            <a href="/contact" className="nav-link">İletişim</a>
            <a href="/cafe-partnership" className="nav-link">Kafe Partnerliği</a>
          </div>
          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </div>
        </div>
      </nav>

      {/* Legal Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-header">
            <h1>Çerez Politikası</h1>
          </div>

          <div className="legal-body">
            <div className="section">
              <h2>1. Çerezler Nedir?</h2>
              <p>
                Çerezler, web sitelerinin kullanıcı deneyimini iyileştirmek için kullandığı küçük metin dosyalarıdır. 
                Bu dosyalar, tarayıcınız tarafından cihazınızda saklanır ve web sitesinin sizi tanımasını sağlar.
              </p>
            </div>

            <div className="section">
              <h2>2. Kullandığımız Çerez Türleri</h2>
              
              <h3>2.1 Gerekli Çerezler</h3>
              <p>Bu çerezler web sitesinin temel işlevlerini yerine getirmesi için gereklidir:</p>
              <ul>
                <li>Oturum yönetimi</li>
                <li>Güvenlik doğrulaması</li>
                <li>Dil tercihleri</li>
                <li>Çerez onay durumu</li>
              </ul>

              <h3>2.2 Performans Çerezleri</h3>
              <p>Web sitesinin performansını analiz etmek için kullanılır:</p>
              <ul>
                <li>Sayfa yükleme süreleri</li>
                <li>Hata raporlama</li>
                <li>Kullanım istatistikleri</li>
              </ul>

              <h3>2.3 Fonksiyonel Çerezler</h3>
              <p>Gelişmiş özellikler ve kişiselleştirme için:</p>
              <ul>
                <li>Kullanıcı tercihleri</li>
                <li>Form verileri</li>
                <li>Özelleştirilmiş içerik</li>
              </ul>

              <h3>2.4 Analitik Çerezler</h3>
              <p>Web sitesi kullanımını anlamak için:</p>
              <ul>
                <li>Google Analytics</li>
                <li>Ziyaretçi davranışları</li>
                <li>Popüler içerik analizi</li>
              </ul>
            </div>

            <div className="section">
              <h2>3. Çerez Yönetimi</h2>
              <p>
                Çerez tercihlerinizi aşağıdaki yollarla yönetebilirsiniz:
              </p>
              <ul>
                <li>Web sitemizdeki çerez ayarları paneli</li>
                <li>Tarayıcı ayarları</li>
                <li>Üçüncü taraf opt-out araçları</li>
              </ul>
            </div>

            <div className="section">
              <h2>4. Üçüncü Taraf Çerezleri</h2>
              <p>Web sitemizde aşağıdaki üçüncü taraf hizmetleri kullanılmaktadır:</p>
              <ul>
                <li><strong>Google Analytics:</strong> Web sitesi analizi</li>
                <li><strong>Google Fonts:</strong> Font yükleme</li>
                <li><strong>Font Awesome:</strong> İkon kütüphanesi</li>
              </ul>
            </div>

            <div className="section">
              <h2>5. Çerez Ayarları</h2>
              <div className="cookie-settings">
                <div className="cookie-category">
                  <h4>Gerekli Çerezler</h4>
                  <p>Bu çerezler web sitesinin çalışması için gereklidir ve kapatılamaz.</p>
                  <div className="toggle-switch disabled">
                    <span>Her zaman aktif</span>
                  </div>
                </div>

                <div className="cookie-category">
                  <h4>Performans Çerezleri</h4>
                  <p>Web sitesi performansını iyileştirmek için kullanılır.</p>
                  <div className="toggle-switch">
                    <input type="checkbox" id="performance" defaultChecked />
                    <label htmlFor="performance"></label>
                  </div>
                </div>

                <div className="cookie-category">
                  <h4>Fonksiyonel Çerezler</h4>
                  <p>Gelişmiş özellikler ve kişiselleştirme için kullanılır.</p>
                  <div className="toggle-switch">
                    <input type="checkbox" id="functional" defaultChecked />
                    <label htmlFor="functional"></label>
                  </div>
                </div>

                <div className="cookie-category">
                  <h4>Analitik Çerezler</h4>
                  <p>Web sitesi kullanımını anlamak için kullanılır.</p>
                  <div className="toggle-switch">
                    <input type="checkbox" id="analytics" defaultChecked />
                    <label htmlFor="analytics"></label>
                  </div>
                </div>
              </div>

              <div className="cookie-actions">
                <button className="btn-primary">Seçimleri Kaydet</button>
                <button className="btn-secondary">Tümünü Kabul Et</button>
                <button className="btn-secondary">Tümünü Reddet</button>
              </div>
            </div>

            <div className="section">
              <h2>6. İletişim</h2>
              <p>
                Çerez politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <a href="/" className="logo-link">
                  <img src="/assets/LogoWhite.png" alt="SobCof Logo" />
                </a>
              </div>
              <p className="footer-description">
                Kahve severler için sosyal keşif platformu. En iyi kafeleri keşfet, yeni insanlarla tanış.
              </p>
              <div className="social-links">
                <a href="https://instagram.com/sobcof" title="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://tiktok.com/@sobcof" title="TikTok" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a>
                <a href="https://twitter.com/sobcof" title="Twitter" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                <a href="https://youtube.com/@sobcof" title="YouTube" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
              </div>
            </div>

            <div className="footer-section">
              <h4>Ürün</h4>
              <ul>
                <li><a href="/#features">Özellikler</a></li>
                <li><a href="/#premium">Premium</a></li>
                <li><a href="/#download">İndir</a></li>
                <li><a href="/#security">Güvenlik</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Destek</h4>
              <ul>
                <li><a href="/help">Yardım Merkezi</a></li>
                <li><a href="/contact">İletişim</a></li>
                <li><a href="/feedback">Geri Bildirim</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Yasal</h4>
              <ul>
                <li><a href="/privacy">Gizlilik Politikası</a></li>
                <li><a href="/terms">Kullanım Koşulları</a></li>
                <li><a href="/cookies">Çerez Politikası</a></li>
                <li><a href="/gdpr">KVKK</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026 SobCof. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CookiesPage;
